import { render, staticRenderFns } from "./BroadcastDeliverTarget.vue?vue&type=template&id=c6bde6c8&scoped=true&"
import script from "./BroadcastDeliverTarget.vue?vue&type=script&lang=js&"
export * from "./BroadcastDeliverTarget.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastDeliverTarget.vue?vue&type=style&index=0&id=c6bde6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bde6c8",
  null
  
)

export default component.exports